module.exports = "/images/icon_social_fb.png?0cebe4a35ea8c63ae53def1e51d93aeb";